var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9223 6.74408C18.2477 7.06951 18.2477 7.59715 17.9223 7.92259L11.8449 14L17.9223 20.0774C18.2477 20.4028 18.2477 20.9305 17.9223 21.2559C17.5968 21.5814 17.0692 21.5814 16.7438 21.2559L10.0771 14.5893C9.75165 14.2638 9.75165 13.7362 10.0771 13.4107L16.7438 6.74408C17.0692 6.41864 17.5968 6.41864 17.9223 6.74408Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.6a580224822a15e284e1ff591a3e1b9d.svg";
export { ForwardRef as ReactComponent };